<template>
  <div class="flex flex-col items-center w-full h-full text-center">
    <SelectCompetitor
      v-if="currentStage === 'competitor'"
      gameId="mapMemory"
      gameTitle="Ski-O Map Memory"
      eventId="e007"
      :allowMultiRun="$route.query.map === 'easy'"
      @competitorSelected="startGame"
    />
    <Countdown
      v-if="currentStage === 'countdown'"
      @timeUp="countdownFinished"
    />
    <template v-if="currentStage === 'game'">
      <h1 class="py-3 text-3xl font-heading">
        Puzzle Number: {{ puzzleNumber }}
      </h1>
      <MapMemoryGame
        :key="`${start}${finish}`"
        :start="start"
        :finish="finish"
        :width="map.width"
        :height="map.height"
        :points="map.points"
        :paths="map.paths"
        :noRestart="true"
        :noRestartAfterFinished="true"
        :nextLeg="true"
        @finished="puzzleComplete"
        @nextLeg="nextPuzzle"
      />
    </template>
    <GameOver
      v-if="currentStage === 'gameOver'"
      :time="time"
      :saveStatus="saveStatus"
      game="Ski-O Map Memory"
      :user="competitor"
    />
  </div>
</template>
<script>
import SelectCompetitor from '@/components/game/SelectCompetitor'
import MapMemoryGame from '@/components/game/MapMemoryGame'
import GameOver from '@/components/game/GameOver'

import Maps from '@/assets/MapMemory'

export default {
  components: {
    SelectCompetitor,
    MapMemoryGame,
    GameOver,
  },

  data: () => ({
    map: {},
    times: [],
    paths: [],
    score: 0,

    puzzleNumber: 1,
    currentStage: 'competitor',
    competitor: false,
    saveStatus: 'pending',
  }),

  computed: {
    start: function () {
      return this?.map?.legs?.[this.puzzleNumber - 1]?.start
    },
    finish: function () {
      return this?.map?.legs?.[this.puzzleNumber - 1]?.finish
    },
    time: function () {
      return this.times.reduce((a, b) => a + b, 0)
    },
  },

  mounted: function () {
    document.title =
      'Orienteering Games - Orienteering Unlocked - Ski-O Map Memory'

    if (this.$route.query.map === 'easy') this.map = Maps.easy
    else this.map = Maps.hard

    window.addEventListener('beforeunload', (event) => {
      if (this.currentStage !== 'game' && this.currentStage !== 'pause')
        return false
      else
        event.returnValue =
          "Are You Sure You Want To Leave The Game? You Can't Restart"
    })
  },

  methods: {
    startGame: function (data) {
      if (data.databaseId) {
        this.competitor = data
        this.currentStage = 'game'
      }
    },

    puzzleComplete: function (data) {
      const { time, path, junctions } = data

      this.paths.push(path)
      this.times.push(time)
      this.score += 50 - junctions

      this.saveResult()
    },

    nextPuzzle: function () {
      if (this.puzzleNumber < this.map.legs.length) this.puzzleNumber += 1
      else {
        this.saveResult(true)
        this.currentStage = 'gameOver'
      }
    },

    saveResult: async function (final = false) {
      const data = {
        databaseId: this.competitor.databaseId,
        times: JSON.stringify(this.times),
        choices: JSON.stringify(this.paths),
        time: this.time,
        score: 'Course A',
        game: 'mapMemory',
      }
      if (this.$route.query.map === 'easy') data.score = 'Course B'

      const uploadResult = fetch(`/api/saveResult`, {
        method: 'POST',
        body: JSON.stringify(data),
      })
        .then((response) => {
          if (!response.ok) throw Error(response.statusText)
          else return response
        })
        .then((response) => response.json())

      if (final && this.competitor.raceNumber > 10)
        return await Promise.all([uploadResult, this.uploadToMainDatabase()])
          .then((response) => {
            if (response[0].success === false) this.saveStatus = 'failed'
            else if (response[0].success === true) this.saveStatus = 'success'
          })
          .catch(() => {
            this.saveStatus = 'failed'
          })
      else if (final)
        return uploadResult
          .then((response) => {
            if (response.success === false) this.saveStatus = 'failed'
            else if (response.success === true) this.saveStatus = 'success'
          })
          .catch(() => {
            this.saveStatus = 'failed'
          })
      else return uploadResult
    },

    uploadToMainDatabase: function () {
      /*
      const data = {
        event: 'e007',
        stage: 's008',
        raceNumber: this.competitor.raceNumber,
        time: this.time,
        course: 'Course A',
      }
      if (this.$route.query.map === 'easy') data.course = 'Course B'

      return fetch(`/api/uploadToMain`, {
        method: 'POST',
        body: JSON.stringify(data),
      })
        .then((response) => {
          if (!response.ok) throw Error(response.statusText)
          else return response
        })
        .then((response) => response.json())
        */
      return Promise.resolve()
    },
  },
}
</script>
